var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.12978L8.49255 4.154C8.63821 4.44915 8.91977 4.65372 9.24548 4.70104L12.5829 5.186L10.1679 7.54003C9.93224 7.76977 9.82469 8.10077 9.88033 8.42517L10.4504 11.7491L7.46534 10.1798C7.17402 10.0266 6.82598 10.0266 6.53466 10.1798L3.54957 11.7491L4.11967 8.42516C4.17531 8.10077 4.06776 7.76977 3.83207 7.54003L1.41709 5.186L4.75452 4.70104C5.08023 4.65372 5.36179 4.44915 5.50745 4.154L7 1.12978Z",
    stroke: "#43494F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLineIcon);
export default __webpack_public_path__ + "static/media/star-line-icon.337d2481ca52b9d128173ab5c6f6e4d1.svg";
export { ForwardRef as ReactComponent };